export default __webpack_public_path__ + "static/media/bears-get-karate-rekt.7b96f373.jpeg";